<template>
  <b-card>
    <FormBuilder
      label="Banner"
      create
      :fields="fields"
      :loading-submit="$store.state.bannerV2.loadingSubmit"
      @submit="submitData"
    />
  </b-card>
</template>

<script>
import FormBuilder from '@/layouts/components/v2/FormBuilder.vue'
import { BCard } from 'bootstrap-vue'
import fields from '@/field/form/banner'

export default {
  components: {
    BCard,
    FormBuilder,
  },
  setup() {
    return { fields }
  },
  methods: {
    submitData(data, callback) {
      this.$store.dispatch('bannerV2/create', data)
        .then(() => {
          if (typeof callback === 'function') callback()
          this.$router.push({ name: 'banners-v2' })
        })
        .catch(err => callback(err))
    },
  },
}
</script>
